import { Dialog, DialogContent, Divider, Grid } from '@mui/material';
import { useState, useEffect, useContext } from 'react';
import DisclaimersText from './DisclaimersText.component';
import { FormContext } from '../../../context/Form.context';

import { Button, Typography } from '@uhc-tempo/components';

const disclaimerStyles = {
    dialogTitle: {
        fontFamily: 'Arial',
        fontSize: '25px',
        color: '#5A5A5A',
    },
    dialogContent: {
        fontFamily: 'sans-serif',
        lineHeight: '1.5',
        color: '#5A5A5A',
        paddingTop: '16px',
        paddingBottom: '16px',
    },
    closeButton: {
        margin: '10px',
    },
    temp: {
        paddingTop: '16px',
        paddingRight: '24px',
        paddingLeft: '24px',
    },
    divider: {
        margin: '0px 24px',
    },
};

export default function DisclaimerModal(props) {
    const { formValues } = useContext(FormContext);
    const { termsAndConditions } = formValues;
    const [disclaimerDialog, setDisclaimerDialog] = useState(false);

    useEffect(() => {}, [termsAndConditions]);

    useEffect(() => {
        if (props.showDisclaimers) {
            setDisclaimerDialog(true);
        } else {
            setDisclaimerDialog(false);
        }
    }, [props.showDisclaimers]);

    useEffect(() => {
        if (disclaimerDialog && document.getElementById('disclaimersDialogChildDiv')) {
            document.getElementById('disclaimersDialogChildDiv').focus();
        }
    }, [disclaimerDialog]);

    return (
        <Dialog
            open={props.showDisclaimers}
            onClose={props.handleDisclaimers}
            data-testid="disclaimers-modal"
            maxWidth={'lg'}
            id="disclaimers-dialog"
            PaperProps={{
                tabIndex: -1,
                id: 'disclaimersDialogChildDiv',
                style: { overflowY: 'hidden' },
                'aria-labelledby': 'disclaimerH2',
            }}
        >
            <Grid item xs={12}>
                <div id="disclaimerHeader">
                    <Grid item xs={12}>
                        <Typography.H2 id="disclaimerH2" style={disclaimerStyles.temp}>
                            {'Important information about your estimate'}
                        </Typography.H2>
                    </Grid>
                </div>
            </Grid>
            <Grid item xs={12}>
                <button
                    className="tds-modal__close"
                    aria-label="close disclaimers"
                    onClick={props.handleDisclaimers}
                    style={{ float: 'right' }}
                >
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        role="presentation"
                        className="tds-modal__close--icon"
                    >
                        <title>Close modal</title>
                        <defs>
                            <rect
                                id="modal_000_close"
                                x="0"
                                y="0"
                                width="14"
                                height="14"
                                rx="8"
                            ></rect>
                        </defs>
                        <g fill="none" fillRule="evenodd">
                            <path
                                d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
                                fill="#196ECF"
                            ></path>
                        </g>
                    </svg>
                </button>
            </Grid>

            <Divider style={disclaimerStyles.divider} role="presentation" aria-hidden="true" />

            <DialogContent dividers={scroll === 'paper'} style={disclaimerStyles.dialogContent}>
                <DisclaimersText genericDisclaimers={termsAndConditions.value} />
            </DialogContent>
            <div style={disclaimerStyles.closeButton}>
                <Button
                    style={{
                        '&:focus': {
                            outline: '#196ecf auto 1px',
                        },
                    }}
                    onClick={props.handleDisclaimers}
                >
                    Close
                </Button>
            </div>
        </Dialog>
    );
}
